import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import UploadButtons from "../../../CustomComponent/UploadButton";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import instructioncontent from "./instructioncontent";
import instructioncontentJeeMain from "./instructioncontentJeeMain";
import instructioncontentSsc from "./instructioncontentSsc";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getSlotListData } from "../../../../service/services";
import { getMarkListData } from "../../../../service/MarkingServices";

const convertImageToBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

function AddExamForm() {
  const classes = useStyles();
  const navigate = useNavigate();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const [examName, setExamName] = useState("");
  const [examSet, setExamSet] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [branches,setBranches]= useState([])
  const [subjects, setSubjects] = useState([]);
  const [subjectList, setSubjectList] = useState([
    { subject_id: "", question_count: "" },
  ]);

  const examSetValues = ["A", "B", "C", "D"];

  useEffect(() => {
    const convertAllImagesToBase64 = async (htmlContent) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const imgTags = doc.querySelectorAll("img");

      for (const img of imgTags) {
        const src = img.getAttribute("src");
        if (src && !src.startsWith("data:")) {
          const base64 = await convertImageToBase64(src);
          img.setAttribute("src", base64);
        }
      }
      return doc.body.innerHTML;
    };
  }, []);

  const fetchBranches= async ()=>{
     try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course/batch/new`,
        {
          center: {courseId: selectedCourse, batchId: selectedBatch}
        },
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (response.data ) {
        setBranches(response.data.response);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  }

   useEffect(()=>{
       fetchBranches()
   },[selectedBatch])


  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/all/active`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );

        // Ensure that the API response contains the 'batch' property
        if (response.data && response.data.courses) {
          setCourses(response.data.courses);
        } else {
          console.error("Invalid API response format:", response);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
 
  }, [decryptedToken]);

  const fetchBatches = async (selectedCourse) => {
    console.log("selectedCourse.length",selectedCourse.length)
    if(selectedCourse.length<1) return ;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
        {
          "batch": {
             "course_ids":selectedCourse
           }
        },
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (response.data && response.data.batches) {
        setBatches(response.data.batches);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    if(selectedCourse.length<1){
     setSelectedBatch([]);
     setSelectedBranch([]);
    }
    
    fetchBatches(selectedCourse);
  }, [selectedCourse]);

 

  const handleCancel = () => {
    navigate("/admin/exam");
  };

  const templates = [
    { name: "IIT MAINS", value: "iit_mains" },
    { name: "NEET", value: "neet" },
    { name: "MHSS", value: "mhss" },
  ];

  const fetchSubjectData = async () => {
    try {
      const response = await axios.get(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/active/list`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      setSubjects(response.data.subjects);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchSubjectData();
  }, []);

  const subjectsData = [
    { id: 1, subject_name: "Physics" },
    { id: 2, subject_name: "Chemistry" },
    { id: 3, subject_name: "Math" },
  ];

  const handleSubjectsChange = (index, value) => {
    const updatedList = [...subjectList];
    updatedList[index].subject_id = value;
    setSubjectList(updatedList);
  };

  const handleBranchChange = (event, newValue) => {
    setSelectedBranch(Array.isArray(newValue) ? newValue.map((center) => center.id) : []);
  };

  const handleQuestionCountChange = (index, value) => {
    const updatedList = [...subjectList];
    updatedList[index].question_count = value;
    setSubjectList(updatedList);
  };

  const handleAddMore = () => {
    setSubjectList([...subjectList, { subject_id: "", question_count: "" }]);
  };

  const handleRemoveLast = () => {
    setSubjectList((prevList) => {
      if (prevList.length > 1) {
        return prevList.slice(0, -1);
      }
      return prevList;
    });
  };

  const handleFormSubmit = async () => {
    if (!examName.trim()) {
      toast.warn("Please enter an exam name.");
      return;
    }
    if (!selectedDate) {
      toast.warn("Please enter a exam date");
      return;
    }
    if (!selectedType) {
      toast.warn("Please select template type");
      return;
    }
    if (!selectedCourse.length) {
      toast.warn("Please select a course .");
      return;
    }
    if (!selectedBatch.length) {
      toast.warn("Please select a batch.");
      return;
    }
    if(!selectedBranch.length) {
      toast.warn("Please select a Branch.");
      return;
    }

    const subjectIds = new Set();
    for (let i = 0; i < subjectList.length; i++) {
      const item = subjectList[i];

      if (!item.subject_id) {
        toast.warn(`Please select a subject for row ${i + 1}.`);
        return;
      }

      if (subjectIds.has(item.subject_id)) {
        toast.warn(
          `Can not select same subject. Please select another subject.`,
        );
        return;
      }

      subjectIds.add(item.subject_id);

      if (
        !item.question_count ||
        isNaN(item.question_count) ||
        Number(item.question_count) <= 0
      ) {
        toast.warn(`Please enter a valid question count for row ${i + 1}.`);
        return;
      }
    }

    try {
      const data = {
        exam: {
          exam_name: examName,
          date: selectedDate,
          template_layout: selectedType,
          sat: examSet,
          course_ids: selectedCourse,
          batch_ids: selectedBatch,
          center_id:selectedBranch,
          subjects: subjectList.map((item) => ({
            subject_id: Number(item.subject_id),
            question_count: Number(item.question_count),
          })),
        },
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Exam created successfully!");
        setTimeout(() => {
          navigate("/admin/exam");
        }, 2000);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        toast.error("An unexpected error occurred while creating the exam.");
      }
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h72vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) => setExamName(e.target.value)}
                  value={examName}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Date <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="date"
                  variant="outlined"
                  required
                  onChange={(e) => setSelectedDate(e.target.value)}
                  value={selectedDate}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Template Layout{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select type</em>
                  </MenuItem>
                  {templates?.map((data, index) => (
                    <MenuItem key={index} value={data.value}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Set
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  value={examSet}
                  onChange={(e) => setExamSet(e.target.value)}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select type</em>
                  </MenuItem>
                  {examSetValues?.map((data, index) => (
                    <MenuItem key={index} value={data}>
                      {data}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Courses <span className={classes.textcolorred}>*</span>
                </FormLabel>
                 <Autocomplete
                  multiple
                  id="courses-multiple"
                  options={courses}
                  getOptionLabel={(option) => option.course_name}
                  value={courses.filter((c) => selectedCourse.includes(c.id))}
                  onChange={(event, newValue) => {
                    setSelectedCourse(Array.isArray(newValue) ? newValue.map((c) => c.id) : []);
                  }}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="courses"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
      
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batches <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="batches-multiple"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((b) => selectedBatch.includes(b.id))}
                  onChange={(event, newValue) =>
                    setSelectedBatch(Array.isArray(newValue) ? newValue.map((b) => b.id) : [])
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="batches"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
        
              </div>

            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
             
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24_5}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Branches <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={branches}
                  getOptionLabel={(option) =>
                    `${option.center_code} - ${option.center_name}`
                  }
                  value={branches?.filter((sub) =>
                    selectedBranch?.includes(sub.id),
                  )}
                  onChange={handleBranchChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
              </div>

             <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
              </div>

            </div>

            {subjectList.map((item, index) => (
              <div
                key={index}
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w37}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Subject <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  {/* <Select
                    value={item.subject_id}
                    onChange={(e) =>
                      handleSubjectsChange(index, e.target.value)
                    }
                    displayEmpty
                    required
                    className={classes.selectEmpty}
                    MenuProps={menuProps}
                    variant="outlined"
                  >
                    <MenuItem disabled value="">
                      <em className={classes.defaultselect}>Select subject</em>
                    </MenuItem>
                    {subjects &&
                      subjects.map((s) => (
                        <MenuItem key={s.id} value={s.id}>
                          {s.subject_name}
                        </MenuItem>
                      ))}
                  </Select> */}
                     <Autocomplete
                  
                  id="tags-standard"
                  options={subjects}
                  getOptionLabel={(option) =>
                    ` ${option.subject_name}`
                  }
                  value={subjects.find((s) => s.id === item.subject_id) || null}
                  onChange={
                    (event, newValue) =>
                      handleSubjectsChange(index, newValue ? newValue.id : null) 
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w36}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Question Count{" "}
                    <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    type="number"
                    value={item.question_count}
                    onChange={(e) =>
                      handleQuestionCountChange(index, e.target.value)
                    }
                    placeholder="Type Here"
                    variant="outlined"
                  />
                </div>
              </div>
            ))}
            <div
              className={`${classes.dflex} ${classes.justifyflexend} ${classes.w100} ${classes.mt1_5} ${classes.gap10}`}
            >
              <Button
                className={`${classes.custombtnblue}`}
                onClick={handleAddMore}
              >
                Add More
              </Button>
              {subjectList.length > 1 && (
                <Button
                  className={`${classes.custombtnoutline}`}
                  onClick={handleRemoveLast}
                >
                  Remove
                </Button>
              )}
            </div>
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleCancel}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}

export default AddExamForm;
